import { useEffect, useState } from "react";

const FULL_MINUTES = 30;
const KEY = "sleep-site-visit-start";

const startTime = () => {
  const saved = Number(sessionStorage.getItem(KEY));
  if (saved) return saved;
  const now = Date.now();
  sessionStorage.setItem(KEY, String(now));
  return now;
};

export const ColourBloom = () => {
  const [bloom, setBloom] = useState(0);

  useEffect(() => {
    const start = startTime();
    const tick = () => {
      const mins = ((Date.now() - start) / 60000) * (window.__bloomScale || 1);
      const b = Math.min(1, mins / FULL_MINUTES);
      const eased = 1 - (1 - b) ** 2;
      setBloom(eased);
      window.__bloom = eased;
      document.documentElement.style.setProperty("--bloom", eased.toFixed(3));
    };
    tick();
    const id = setInterval(tick, 2000);
    return () => clearInterval(id);
  }, []);

  return <div className="colour-bloom" data-testid="colour-bloom" data-bloom={bloom.toFixed(2)} aria-hidden="true" />;
};
